import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="container mx-auto px-4 py-24 text-center">
      <p className="text-6xl font-bold text-gradient mb-4">404</p>
      <h1 className="text-2xl font-bold mb-4">页面未找到</h1>
      <p className="text-purple-200 mb-8">您访问的页面不存在或已被移动。</p>
      <Link
        to="/"
        className="inline-flex items-center bg-gradient-to-r from-primary to-secondary px-8 py-3 rounded-full font-medium hover:opacity-90"
      >
        <i className="fa fa-home mr-2" /> 返回首页
      </Link>
    </section>
  );
}
